export default __webpack_public_path__ + "static/media/swiper2.3f84882a.png";